
export default {
  name: 'input-color',

  props: {
    value: {
      type: String
    }
  },

  data: function data() {
    return {
      color: ''
    };
  },


  computed: {
    style: function style() {
      return {
        background: this.color
      };
    }
  },

  watch: {
    value: function value(val) {
      this.color = val;
    }
  },

  methods: {
    handleChange: function handleChange(event) {
      this.$emit('change', event.target.value);
    },
    handleInput: function handleInput(event) {
      this.color = event.target.value;
    },
    openColorDialog: function openColorDialog() {
      this.$refs.colorInput.click();
    }
  },

  mounted: function mounted() {
    this.color = this.value;
  }
};